import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState, useReducer } from 'react';
import { createAction } from 'typesafe-actions';
import { checkPassword } from '@segment/api/staticSiteBackend/signup';
import { passwordErrorMessages } from './data';
var VALID = "VALID";
var ERROR = "ERROR";
var REQUIRED = "REQUIRED";
var TOO_WEAK = "TOO_WEAK";
var TOO_SHORT = "TOO_SHORT";
var NOT_SECURE = "NOT_SECURE";
var validAction = createAction(VALID)();
var errorAction = createAction(ERROR)();
var requiredAction = createAction(REQUIRED)();
var tooWeakAction = createAction(TOO_WEAK)();
var tooShortAction = createAction(TOO_SHORT)();
var notSecureAction = createAction(NOT_SECURE)();
var DEFAULT_OPTIONS = {
  errorMessage: undefined,
  valid: undefined,
  isPwned: false,
  isComplex: false,
  score: undefined
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ERROR:
      {
        return {
          errorMessage: "Error trying to fetch email checking from API",
          valid: false,
          isPwned: false,
          isComplex: true,
          score: 0,
          error: true
        };
      }

    case VALID:
      {
        return {
          errorMessage: undefined,
          valid: true,
          isPwned: state.isPwned,
          isComplex: true,
          score: action.payload.score
        };
      }

    case REQUIRED:
      {
        return {
          errorMessage: passwordErrorMessages.required,
          valid: undefined,
          isPwned: false,
          isComplex: false,
          score: undefined
        };
      }

    case TOO_WEAK:
      {
        return {
          errorMessage: passwordErrorMessages.tooWeak,
          valid: false,
          isPwned: state.isPwned,
          isComplex: false,
          score: 0
        };
      }

    case NOT_SECURE:
      {
        return {
          errorMessage: passwordErrorMessages.notSecure,
          valid: false,
          isPwned: true,
          isComplex: action.payload.complex,
          score: action.payload.score
        };
      }

    case TOO_SHORT:
      {
        return {
          errorMessage: passwordErrorMessages.tooShort,
          valid: false,
          isPwned: action.payload.compromised,
          isComplex: action.payload.complex,
          score: action.payload.score
        };
      }

    default:
      {
        return DEFAULT_OPTIONS;
      }
  }
};

var usePassword = function usePassword() {
  var _useState = useState(undefined),
      value = _useState[0],
      setValue = _useState[1];

  var _useReducer = useReducer(reducer, DEFAULT_OPTIONS),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var valid = state.valid,
      isPwned = state.isPwned,
      isComplex = state.isComplex,
      score = state.score,
      errorMessage = state.errorMessage,
      error = state.error;

  var checkStrength = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(password) {
      var MIN_PASSWORD_LENGTH, MIN_VALID_SCORE, controller, pwdStrength, compromised, weak, _short, _score;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              MIN_PASSWORD_LENGTH = 8;
              MIN_VALID_SCORE = 1;
              setValue(password);

              if (!(password === "")) {
                _context.next = 6;
                break;
              }

              dispatch(requiredAction());
              return _context.abrupt("return");

            case 6:
              _context.prev = 6;
              controller = new AbortController();
              _context.next = 10;
              return checkPassword(controller.signal, password);

            case 10:
              pwdStrength = _context.sent;
              compromised = typeof pwdStrength.pwned === "number" && pwdStrength.pwned > 0;
              weak = typeof pwdStrength.score === "number" && pwdStrength.score <= MIN_VALID_SCORE;
              _short = password.length < MIN_PASSWORD_LENGTH;
              _score = pwdStrength.score;

              if (weak) {
                dispatch(tooWeakAction());
              } else if (_short) {
                dispatch(tooShortAction({
                  score: _score,
                  complex: !weak,
                  compromised: compromised
                }));
              } else if (compromised) {
                dispatch(notSecureAction({
                  score: _score,
                  complex: !weak
                }));
              } else {
                dispatch(validAction({
                  score: _score
                }));
              }

              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              dispatch(errorAction({
                error: true
              }));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18]]);
    }));

    return function checkStrength(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    valid: valid,
    isPwned: isPwned,
    isComplex: isComplex,
    score: score,
    errorMessage: errorMessage,
    password: value,
    apiError: error,
    checkStrength: checkStrength
  };
};

export { usePassword };